import React, { Component } from "react";
import { InputField } from "../../../../common/custom-form/input-filter-component";
import { SelectField } from "../../../../common/custom-form/select-filter.component";

export class ManageVendorDetails extends Component {
    constructor(props){
        super(props);
        this.state={
            inputValue: "",
            filterSelected: "", 
            showTable: false,
            showRate: false,
            detailsDropdown:[
                {
                    "title":"Plan Features",
                    "subTitle":"Feature Name",
                    "dataTable":[
                        {              
                            HeaderItem:[
                                {
                                    name:"Contract Name"
                                },
                                {
                                    name:"Vendor"
                                }, {
                                    name:"Status"
                                },{
                                    showTable:false
                                }
                            ],
                            dataItem:[{            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"                       
                            }, {            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"
                            },{            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"
                            }        
                            ]
            
                        }
                    ]
                },{
                    "title":"Plan Rates",
                    "subTitle":"Rate Name",
                    "dataTable":[
                        {              
                            HeaderItem:[
                                {
                                    name:"Contract Name"
                                },
                                {
                                    name:"Vendor"
                                }, {
                                    name:"Status"
                                }, {
                                    showTable:false
                                }
                            ],
                            dataItem:[{            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"                       
                            }, {            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"
                            },{            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"
                            }        
                            ]
            
                        }
                    ]
                }
            ],
            selectFilter:[
                {
                    "FilterId":5,
                    "FilterName":"Account Number",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":4,
                    "FilterName":"Circuit ID",
                    "FilterType":"Textbox","Page":
                    "CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":7,
                    "FilterName":"Circuit Status",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                }
               ],
               dataTable:[
                {              
                    HeaderItem:[
                        {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        }
                    ],
                    dataItem:[{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"                       
                    }, {            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    },{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    }        
                    ]
    
                }
            ],
        }
    }

  
    render() {
        return(
            <>
                <div className="manage-order-container">
                        <div className="manage-order-detail">
                            <SelectField label="VENDOR NAME"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/> 
                            <SelectField label="COUNTRY"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                
                            <InputField label="CURRENCY" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="AP VENDOR ID" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="AP COUNTRY CODE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="STATUS" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                        </div>
                </div> 

                <h1>Service Account Contact</h1>
                <div className="manage-order-container">
                        <div className="manage-order-detail">
                            <InputField label="PRIMARY CONTACT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="EMAIL ADDRESS" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="TELEPHONE NO." testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="MOBILE NO" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                        </div>
                </div>   
                <h1>Order Contact</h1>
                <div className="manage-order-container">
                        <div className="manage-order-detail">
                            <InputField label="PRIMARY CONTACT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="EMAIL ADDRESS" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="SECONDARY CONTACT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="SECONDARY EMAIL ADDRESS" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="TELEPHONE NO." testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="MOBILE NO" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                        </div>
                </div>  
                <h1>Billing Contact</h1>
                <div className="manage-order-container">
                        <div className="manage-order-detail">
                            <InputField label="PRIMARY CONTACT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="EMAIL ADDRESS" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="TELEPHONE NO." testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="MOBILE NO" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                        </div>
                </div>                      
            </>
        )
    }
}